import React, { useEffect } from 'react';
import { SocketProvider, useSocket } from './contexts/SocketContext';
import { FontSizeProvider } from './contexts/FontSizeContext';
import Cursor from './components/common/Cursor';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box, Spinner, Center, ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import SheetManager from './components/sheets/SheetManager';
import AnalyticsPage from './pages/AnalyticsPage';
import NewKanbanBoardPage from './pages/NewKanbanBoardPage';
import TanStackKanbanPage from './pages/TanStackKanbanPage';
import AuthTokenPage from './pages/AuthTokenPage';
import TasksPage from './pages/TasksPage';
import ExportPage from './pages/ExportPage';

import { useAuth } from './contexts/AuthContext';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Cursor tracking functionality commented out to reduce network traffic and console noise
const CursorTracker = () => {
  // const { updateCursorPosition, cursors } = useSocket();
  // const location = useLocation();

  // useEffect(() => {
  //   // Only track cursors on the homepage
  //   if (location.pathname !== '/') return;
  //   let throttleTimeout;

  //   const handleMouseMove = (e) => {
  //     if (!throttleTimeout) {
  //       throttleTimeout = setTimeout(() => {
  //         updateCursorPosition({
  //           x: e.clientX,
  //           y: e.clientY
  //         });
  //         throttleTimeout = null;
  //       }, 50); // Throttle to 50ms
  //     }
  //   };

  //   window.addEventListener('mousemove', handleMouseMove);
  //   return () => {
  //     window.removeEventListener('mousemove', handleMouseMove);
  //     if (throttleTimeout) {
  //       clearTimeout(throttleTimeout);
  //     }
  //   };
  // }, [updateCursorPosition]);

  // // Only show cursors on the homepage
  // if (location.pathname !== '/') return null;

  // return (
  //   <>
  //     {Object.entries(cursors).map(([userId, { position, user }]) => (
  //       <Cursor key={userId} position={position} user={user} />
  //     ))}
  //   </>
  // );
  
  // Return null instead of cursor elements
  return null;
};

const App = () => {
  const { loading } = useAuth();

  if (loading) {
    return (
      <ChakraProvider theme={theme}>
        <Center h="100vh">
          <Spinner size="xl" />
        </Center>
      </ChakraProvider>
    );
  }

  return (
    <ChakraProvider theme={theme}>
      <SocketProvider>
        <FontSizeProvider>
          <Box minH="100vh">
            <CursorTracker />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/old-kanban"
                element={
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sheets"
                element={
                  <ProtectedRoute>
                    <SheetManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analytics"
                element={
                  <ProtectedRoute>
                    <AnalyticsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tanstack"
                element={
                  <ProtectedRoute>
                    <TanStackKanbanPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/auth-token"
                element={
                  <ProtectedRoute>
                    <AuthTokenPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tasks"
                element={
                  <ProtectedRoute>
                    <TasksPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/exports"
                element={
                  <ProtectedRoute>
                    <ExportPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <NewKanbanBoardPage />
                  </ProtectedRoute>
                }
              />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Box>
        </FontSizeProvider>
      </SocketProvider>
    </ChakraProvider>
  );
};

export default App;
